import { nextTick, useTemplateRef, watch, type Ref } from 'vue'
import type FilterAccordion from '@/components/ui/filter/FilterAccordion.vue'

export function useFocusAccordion(isOpen: Readonly<Ref<boolean>>) {
    const filterAccordionNode = useTemplateRef<
        InstanceType<typeof FilterAccordion>
    >('filterAccordionNode')

    watch(isOpen, (isOpen) => {
        if (isOpen) {
            nextTick(() => {
                filterAccordionNode.value?.titleEl?.focus()
            })
        }
    })

    return { filterAccordionNode }
}
